import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

import { daysOfWeek } from '@/constants/base';
import newsFilter from '@/constants/newsFilter';

const useWorkDays = (count = 5) => {
  const { t, lang } = useTranslation();
  const newsFilterData = newsFilter();
  const monthOptions = newsFilterData.find(
    (filter) => filter.name === 'month',
  ).options;

  const workDays = useMemo(() => {
    const today = new Date();
    return Array.from({ length: count * 2 }).reduce((days, _, i) => {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      const day = date.getDay();

      if (day >= 1 && day <= 5 && days.length < count) {
        const monthNumber = date.getMonth() + 1;
        const monthName = monthOptions.find(
          (option) => option.value === monthNumber.toString(),
        )?.name;
        const translatedMonthName = t(monthName) || monthName;

        const formattedDate = `${date
          .getDate()
          .toString()
          .padStart(2, '0')} ${translatedMonthName}`;
        days.push(`${formattedDate}, ${daysOfWeek[lang || 'az'][day]}`);
      }
      return days;
    }, []);
  }, [count, t, lang]);

  return workDays;
};

export default useWorkDays;
